// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"650f9b2960421670bd93","245":"43f618560fbfefb712f9","452":"64004123cea2c8bb0e95","453":"21fc634451046e26bb40"}[chunkId] + ".js";
};